import 'babel-polyfill'
import 'promise-polyfill/src/polyfill'
import 'whatwg-fetch'

import Vue from 'vue'
import App from './App'
import {
  Vuetify,
  VApp,
  VGrid,
  VSelect,
  VBtn,
  VIcon,
  VDataTable,
  VList,
  VMenu,
  transitions
} from 'vuetify'
import 'vuetify/src/stylus/app.styl'

Vue.use(Vuetify, {
  components: {
    VApp,
    VGrid,
    VSelect,
    VBtn,
    VIcon,
    VDataTable,
    VList,
    VMenu,
    transitions
  }
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js